module.exports = __webpack_public_path__ + "img/index_apps.a9dbf52d.png";